import { render, staticRenderFns } from "./BlogDetailV.vue?vue&type=template&id=9fd927a8&scoped=true"
import script from "./BlogDetailV.vue?vue&type=script&lang=js"
export * from "./BlogDetailV.vue?vue&type=script&lang=js"
import style0 from "./BlogDetailV.vue?vue&type=style&index=0&id=9fd927a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fd927a8",
  null
  
)

export default component.exports